var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBottomBarMegWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8822 1.66699C16.6572 1.66699 18.7497 3.93116 18.7497 6.93366V12.657C18.7497 14.1937 18.2063 15.582 17.2188 16.567C16.333 17.4495 15.1838 17.917 13.8955 17.917H5.68467C4.39884 17.917 3.25051 17.4503 2.36384 16.567C1.37634 15.582 0.833008 14.1937 0.833008 12.657V6.93366C0.833008 3.93116 2.92551 1.66699 5.70051 1.66699H13.8822ZM13.8822 2.91699H5.70051C3.60467 2.91699 2.08301 4.60616 2.08301 6.93366V12.657C2.08301 13.8595 2.49634 14.9337 3.24634 15.6812C3.89301 16.327 4.73717 16.667 5.68717 16.667H13.8822C13.8838 16.6653 13.8905 16.667 13.8955 16.667C14.8463 16.667 15.6897 16.327 16.3363 15.6812C17.0872 14.9337 17.4997 13.8595 17.4997 12.657V6.93366C17.4997 4.60616 15.978 2.91699 13.8822 2.91699ZM15.1955 6.77433C15.413 7.04183 15.3722 7.43516 15.1047 7.65349L11.4013 10.6635C10.933 11.0352 10.373 11.221 9.81384 11.221C9.25634 11.221 8.70051 11.0368 8.23551 10.6685L4.49801 7.65516C4.22884 7.43849 4.18717 7.04433 4.40301 6.77599C4.62051 6.50849 5.01384 6.46599 5.28217 6.68183L9.01634 9.69182C9.48551 10.0635 10.1463 10.0635 10.6188 9.68849L14.3155 6.68349C14.5838 6.46433 14.9772 6.50599 15.1955 6.77433Z",
    fill: "#222222",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomBarMegWhite);
export default __webpack_public_path__ + "static/media/bottom-bar-meg-white.50f11804e7580f66181b59e8f7922b06.svg";
export { ForwardRef as ReactComponent };